export default function(o, onTogglePlay){

  var iconDiv = o.svgs.play.svg
  .clone()
  .css({
    width: '5em',
    height: '5em',
    filter: 'drop-shadow(rgba(0, 0, 0, 0.5) 0px 0.15em 0.15em)',
  })
  // .hover(function(){
  //   iconDiv
  //   .find('*')
  //   .attr({fill: o.colors.red})
  // },function(){
  //   iconDiv
  //   .find('*')
  //   .attr({fill: o.colors.yellow})
  // })
  // .click(onTogglePlay)

  var div =
    $('<div>')
    .css({
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      cursor: "pointer",
    })
    .append([
      iconDiv,
    ])

  return div

}



// WEBPACK FOOTER //
// ./src/client/view/frontend/views/story/play/play.js